import { ApiConfig } from 'src/plugins/api/declare'

const apiConfig: ApiConfig[] = [
  {
    name: 'getStatisticsData',
    method: 'POST',
    path: '/OP/Tenant/GetStatisticsData',
    params: {},
    axiosOptions: {},
    desc: '租户浏览统计'
  },
]

export default apiConfig